import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { Context as SocketContext } from '../../../../components/Websocket';
import { absolute } from '../../components/AnimatedRoutes';
import { getPlacement } from '../../../../ducks/question';
import ClaimPrompt from './ClaimPrompt';
import Content from '../../components/Content';
import Empty from '../../components/Empty';
import Flash from '../../components/Flash';
import Header from '../../components/Header';
import Loader from '../../components/Loader';
import styles from './question.scss';
import withUser from '../../../../components/withUser';

const propTypes = {
  claimed: PropTypes.bool,
  history: PropTypes.shape({
    stackPop: PropTypes.func.isRequired,
  }).isRequired,
  submitError: PropTypes.shape({
    response: PropTypes.shape({
      status: PropTypes.string,
    }),
  }),
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  quizOpen: PropTypes.bool,
  placement: PropTypes.shape({
    position: PropTypes.number,
    out_of: PropTypes.number,
  }),
  dispatch: PropTypes.func.isRequired,
  leaderboard: PropTypes.string,
  question: ImmutablePropTypes.map,
};

const errorMessages = (code) => {
  switch (code) {
    case 409:
      return 'You\'ve already answered this question.';
    case 408:
      return 'The question is closed for answers.';
    default:
      return 'Something went wrong and we\'re not sure why.';
  }
};

// eslint-disable-next-line
class Waiting extends React.Component {

  componentDidMount() {
    const { user, dispatch, leaderboard } = this.props;
    if (user && user.id && leaderboard) {
      dispatch(getPlacement(leaderboard));
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      leaderboard,
      user,
      dispatch,
      question,
    } = this.props;
    const { leaderboard: newLeaderboard, question: newQuestion } = newProps;
    if (user && user.id && (
      (leaderboard !== newLeaderboard) || (question && newQuestion && (question.get('id') !== newQuestion.get('id')))
    )) {
      dispatch(getPlacement(newLeaderboard));
    }
  }

  render() {
    const {
      claimed,
      submitError,
      history,
      quizOpen,
      placement,
      user,
    } = this.props;

    const { channels, online } = this.context;

    const quizReady = channels && online && !!channels.find((c) => c.channel === 'quiz');

    const errorMessage = submitError && submitError.response
      && errorMessages(submitError.response.status);

    return (
      <>
        <Header onBack={() => history.stackPop()}>
          Quiz
        </Header>
        <ClaimPrompt history={history} />
        <Flash
          title="Got them!"
          message={claimed && 'We connected your answers to this account.'}
          neutral
        />
        <Flash
          title="Woops!"
          message={submitError && errorMessage}
          error
        />
        <Content>
          <div className={styles.ready}>
            { quizReady && quizOpen
              && (
                <>
                  <div className={styles.spinner}>
                    <div className={styles.db1} />
                    <div className={styles.db2} />
                  </div>
                  <div className={styles.waiting}>
                    Get ready!
                  </div>
                  <div className={styles.explanation}>
                    Quiz questions are sent out at DreamHack events during broadcasts
                    and breaks between games. The quiz is currently live, get ready for
                    the next question!
                  </div>
                  { placement && ((placement.position && placement.out_of)
                  || (placement.position === 0 && placement.out_of > 0)) ? (
                    <div className={styles.placement}>
                      You are in place{' '}
                      <strong>
                        {placement.position === 0 ? placement.out_of : placement.position}
                      </strong>
                      {' '}of <strong>{placement.out_of}</strong>
                      {' '}in the current leaderboard.
                    </div>
                    ) : null }
                  { !user && (
                  <div className={styles.placement}>
                    <span>Log in to see your placement in the leaderboard.</span>
                  </div>
                  )}
                </>
              )}
            { quizReady && !quizOpen
              && (
                <>
                  <div className={styles.waiting}>
                    The quiz is closed
                  </div>
                  <div className={styles.explanation}>
                    Quiz questions are sent out at DreamHack events during broadcasts
                    and breaks between games. The quiz is currently closed. Make sure
                    to tune in to our events to catch the next one!
                  </div>
                </>
              )}
            { !quizReady && online
              && (
                <>
                  <div>
                    <Loader loading />
                  </div>
                  <div className={styles.waiting}>
                    Connecting...
                  </div>
                </>
              )}
            { online === false
              && (
              <Empty
                error
                empty
                message="Looks like we couldn\'t reach DreamHack. Try again in a moment."
              />
              )}
          </div>
        </Content>
      </>
    );
  }
}

Waiting.propTypes = propTypes;
Waiting.contextType = SocketContext;

function mapStateToProps(state) {
  return {
    loading: state.getIn(['question', 'loading']),
    question: state.getIn(['question', 'data']),
    error: state.getIn(['question', 'error']),
    claimed: state.getIn(['question', 'claimed']),
    quizOpen: state.getIn(['app', 'settings', 'quizOpen']),
    leaderboard: state.getIn(['app', 'settings', 'leaderboard']),
    placement: state.getIn(['question', 'placement']),
  };
}

export default withUser(connect(mapStateToProps)(absolute(Waiting)));
